import moment from 'moment'
import {
  ExecutionDetailResponse,
  TriggeredExecutionListResponse
} from '../types/TriggeredExecution'
import { ScriptFeedbackStep } from '../../mScripts/tessaScript/types/ScriptExecution'

const today = moment().format('YYYY-MM-DD')
const yesterday = moment().subtract(1, 'day').format('YYYY-MM-DD')
const tomorrow = moment().add(1, 'day').format('YYYY-MM-DD')

// Commented out triggered execution mock items
// export const TRIGGERED_EXECUTIONS_MOCK: TriggeredExecutionListResponse = {
//   triggeredExecutions: [
//     {
//       triggeredExecutionId: 100,
//       executedAt: `${yesterday}T09:15:00.000Z`,
//       script: {
//         scriptReferenceId: 456,
//         scriptVersionId: 789,
//         scriptName: 'Geel alarm: iets langer in bed'
//       },
//       trigger: {
//         triggeringEventId: 111,
//         triggerName: 'Geel alarm trigger'
//       }
//     },
//     {
//       triggeredExecutionId: 101,
//       executedAt: `${today}T14:30:00.000Z`,
//       script: {
//         scriptReferenceId: 457,
//         scriptVersionId: 790,
//         scriptName: 'Rood alarm: gevallen'
//       },
//       trigger: {
//         triggeringEventId: 112,
//         triggerName: 'Rood alarm trigger'
//       }
//     },
//     {
//       triggeredExecutionId: 102,
//       executedAt: `${tomorrow}T16:00:00.000Z`,
//       script: {
//         scriptReferenceId: 458,
//         scriptVersionId: 791,
//         scriptName: 'Groen alarm: inactief'
//       },
//       trigger: {
//         triggeringEventId: 113,
//         triggerName: 'Groen alarm trigger'
//       }
//     }
//   ]
// }

export const TRIGGERED_EXECUTIONS_MOCK: TriggeredExecutionListResponse = {
  triggeredExecutions: []
}

export const TRIGGERED_EXECUTION_DETAIL_MOCK: ExecutionDetailResponse & {
  scriptFeedbackSteps: ScriptFeedbackStep[]
} = {
  id: 100,
  executionType: 'triggered',
  executedAt: `${yesterday}T09:15:00.000Z`,
  script: {
    scriptReferenceId: 456,
    scriptVersionId: 789,
    scriptName: 'Geel alarm: iets langer in bed'
  },
  trigger: {
    triggeringEventId: 111,
    triggerName: 'Geel alarm trigger'
  },
  scriptExecutionSteps: [
    {
      id: 1,
      scriptStepId: 20,
      stepType: 'say',
      nextScriptStepId: 21,
      executedAt: `${yesterday}T09:15:00.000Z`,
      data: null
    },
    {
      id: 2,
      scriptStepId: 21,
      stepType: 'wait',
      nextScriptStepId: 22,
      executedAt: `${yesterday}T09:15:02.000Z`,
      data: null
    },
    {
      id: 3,
      scriptStepId: 22,
      stepType: 'closedQuestion',
      nextScriptStepId: 23,
      executedAt: `${yesterday}T09:15:05.123Z`,
      data: {
        answer: 'ja',
        probability: 0.95,
        dataType: 'closedQuestionData'
      }
    },
    {
      id: 4,
      scriptStepId: 23,
      stepType: 'say',
      nextScriptStepId: null,
      executedAt: `${yesterday}T09:15:08.456Z`,
      data: null
    }
  ],
  // Pre-computed feedback steps for rendering (includes step text for mock phase).
  // When BE integration is complete, these should be derived by fetching the script
  // definition (scriptReferenceId) and mapping execution steps via getFeedbackSteps selector.
  scriptFeedbackSteps: [
    {
      type: 'say',
      text: 'Fijne ochtend op deze mooie dag! Ik heb gemerkt dat u iets langer in bed blijft.',
      notify: false,
      greet: false,
      sayTime: false,
      retryOnOther: false,
      executionTime: `${yesterday}T09:15:00.000Z`
    },
    {
      type: 'wait',
      seconds: 2,
      executionTime: `${yesterday}T09:15:02.000Z`
    },
    {
      type: 'ask',
      text: 'Heb je al een kopje thee of iets anders te drinken gekregen?',
      answer: 'yes',
      notify: false,
      greet: false,
      sayTime: false,
      retryOnOther: false,
      executionTime: `${yesterday}T09:15:05.123Z`
    },
    {
      type: 'say',
      text: 'Goed idee, lekker starten is de sleutel voor een fijne dag!',
      notify: false,
      greet: false,
      sayTime: false,
      retryOnOther: false,
      executionTime: `${yesterday}T09:15:08.456Z`
    }
  ]
}

export const TRIGGERED_EXECUTION_DETAIL_MOCK_101: ExecutionDetailResponse & {
  scriptFeedbackSteps: ScriptFeedbackStep[]
} = {
  id: 101,
  executionType: 'triggered',
  executedAt: `${today}T14:30:00.000Z`,
  script: {
    scriptReferenceId: 457,
    scriptVersionId: 790,
    scriptName: 'Rood alarm: gevallen'
  },
  trigger: {
    triggeringEventId: 112,
    triggerName: 'Rood alarm trigger'
  },
  scriptExecutionSteps: [
    {
      id: 1,
      scriptStepId: 30,
      stepType: 'say',
      nextScriptStepId: 31,
      executedAt: `${today}T14:30:00.000Z`,
      data: null
    },
    {
      id: 2,
      scriptStepId: 31,
      stepType: 'closedQuestion',
      nextScriptStepId: 32,
      executedAt: `${today}T14:30:03.000Z`,
      data: {
        answer: 'ja',
        probability: 0.88,
        dataType: 'closedQuestionData'
      }
    },
    {
      id: 3,
      scriptStepId: 32,
      stepType: 'say',
      nextScriptStepId: null,
      executedAt: `${today}T14:30:06.500Z`,
      data: null
    }
  ],
  scriptFeedbackSteps: [
    {
      type: 'say',
      text: 'Ik heb een val gedetecteerd. Bent u oké?',
      notify: false,
      greet: false,
      sayTime: false,
      retryOnOther: false,
      executionTime: `${today}T14:30:00.000Z`
    },
    {
      type: 'ask',
      text: 'Heeft u hulp nodig?',
      answer: 'yes',
      notify: true,
      greet: false,
      sayTime: false,
      retryOnOther: false,
      executionTime: `${today}T14:30:03.000Z`
    },
    {
      type: 'say',
      text: 'Ik heb uw verzorger gewaarschuwd. Ze komen zo snel mogelijk.',
      notify: false,
      greet: false,
      sayTime: false,
      retryOnOther: false,
      executionTime: `${today}T14:30:06.500Z`
    }
  ]
}

export const TRIGGERED_EXECUTION_DETAIL_MOCK_102: ExecutionDetailResponse & {
  scriptFeedbackSteps: ScriptFeedbackStep[]
} = {
  id: 102,
  executionType: 'triggered',
  executedAt: `${tomorrow}T16:00:00.000Z`,
  script: {
    scriptReferenceId: 458,
    scriptVersionId: 791,
    scriptName: 'Groen alarm: inactief'
  },
  trigger: {
    triggeringEventId: 113,
    triggerName: 'Groen alarm trigger'
  },
  scriptExecutionSteps: [
    {
      id: 1,
      scriptStepId: 40,
      stepType: 'say',
      nextScriptStepId: 41,
      executedAt: `${tomorrow}T16:00:00.000Z`,
      data: null
    },
    {
      id: 2,
      scriptStepId: 41,
      stepType: 'closedQuestion',
      nextScriptStepId: 42,
      executedAt: `${tomorrow}T16:00:04.000Z`,
      data: null
    },
    {
      id: 3,
      scriptStepId: 42,
      stepType: 'say',
      nextScriptStepId: null,
      executedAt: `${tomorrow}T16:00:07.000Z`,
      data: null
    }
  ],
  scriptFeedbackSteps: [
    {
      type: 'say',
      text: 'Ik merk dat u de afgelopen tijd weinig actief bent geweest. Gaat alles goed?',
      notify: false,
      greet: false,
      sayTime: false,
      retryOnOther: false,
      executionTime: `${tomorrow}T16:00:00.000Z`
    },
    {
      type: 'ask',
      text: 'Wilt u dat ik iemand waarschuw?',
      notify: false,
      greet: false,
      sayTime: false,
      retryOnOther: false,
      executionTime: `${tomorrow}T16:00:04.000Z`
    },
    {
      type: 'say',
      text: 'Oké, ik houd het in de gaten. Vergeet niet wat water te drinken.',
      notify: false,
      greet: false,
      sayTime: false,
      retryOnOther: false,
      executionTime: `${tomorrow}T16:00:07.000Z`
    }
  ]
}
